import { Avatar } from "@app/design-system/components";
import styles from "./DriverMarker.module.css";

export type DriverMarkerProps = {
  name: string;
  avatarUrl?: string;
};

/**
 * The driver's live position: their profile photo in a ringed circle — no
 * pointer tail, unlike Pickup/Dropoff, since it's a floating live position
 * rather than a fixed pin (see the center- vs. bottom-anchoring split in
 * each adapter). Reuses the design-system `Avatar` (initials fallback when
 * there's no photo) instead of a bespoke image element.
 */
export const DriverMarker = ({ name, avatarUrl }: DriverMarkerProps) => (
  <span className={styles.wrapper}>
    <Avatar name={name} src={avatarUrl} size="md" />
  </span>
);
